import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const JOB_FUNCTION_UPDATE_RESOURCE = "job-function" as const;
export const JOB_FUNCTION_UPDATE_API_PATH = `/v1/${JOB_FUNCTION_UPDATE_RESOURCE}/{uuid}` as const;

export type JobFunctionUpdateBody =
  paths[typeof JOB_FUNCTION_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type JobFunctionUpdateResponse =
  paths[typeof JOB_FUNCTION_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useJobFunctionUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<JobFunctionUpdateResponse, Error, JobFunctionUpdateBody & { uuid: string }>({
    mutationFn: async (jobFunction: JobFunctionUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = jobFunction;
      const response = await alphartisApiAxios.patch<JobFunctionUpdateResponse>(
        `/v1/${JOB_FUNCTION_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [JOB_FUNCTION_UPDATE_RESOURCE],
      });
    },
  });
};
